module.exports = __webpack_public_path__ + "img/speaker-person.bc46dc67.jpg";